const Applicant = () => import("@/modules/applicants/pages/Applicant.vue");
const Summary = () => import("@/modules/applicants/pages/Summary.vue");
const DataPoints = () => import("@/modules/applicants/pages/DataPoints.vue");
const JSONPage = () => import("@/modules/applicants/pages/JSONPage.vue");

export default [
  {
    path: "applicant/:applicantId",
    component: Applicant,
    children: [
      {
        path: "summary",
        name: "summary",
        component: Summary,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "datapoints",
        name: "datapoints",
        component: DataPoints,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "json",
        name: "json",
        component: JSONPage,
        meta: {
          authRequired: true,
        },
      },
    ],
    meta: {
      authRequired: true,
    },
  },
];
